import React from 'react';

const CombineMetadata = ({ label, determinationDate }) => {
  const decisionDate = new Date(determinationDate);
  const day = decisionDate.getDate();
  const month = decisionDate.toLocaleString('default', { month: 'long' });
  const year = decisionDate.getFullYear();
  const determinationDateFormatted = determinationDate ? `${day} ${month} ${year}` : null;
  return (
    <>
      {label}
      <br></br>
      {determinationDateFormatted}
    </>
  );
};

export default CombineMetadata;
